/**
 * API Configuration - Centralized Single Source of Truth
 * Uses relative paths that nginx will proxy to backend services
 */

export interface ApiEndpoints {
  authApi: string;
  schoolApi: string;
  learningApi: string;
  cdnBaseUrl: string;
}

// Centralized configuration - Use relative paths for nginx proxy
const getApiEndpoints = (): ApiEndpoints => {
  // Use relative paths that nginx will proxy to backend services
  const authApi = '/api/auth';
  const schoolApi = '/api/school';
  const learningApi = '/api/learning';
  const cdnBaseUrl = '/api/cdn';

  return {
    authApi,
    schoolApi,
    learningApi,
    cdnBaseUrl
  };
};

export const API_ENDPOINTS = getApiEndpoints();

// Debug logging based on environment
const environment = import.meta.env.VITE_ENVIRONMENT || 'development';
console.log(`🚀 ${environment.toUpperCase()} API Configuration:`);
console.log('Environment:', environment);
console.log('Auth API:', API_ENDPOINTS.authApi);
console.log('School API:', API_ENDPOINTS.schoolApi);
console.log('Learning API:', API_ENDPOINTS.learningApi);

// Validate that we're not using localhost in production environment
if (environment === 'production') {
  const endpoints = [API_ENDPOINTS.authApi, API_ENDPOINTS.schoolApi, API_ENDPOINTS.learningApi];
  const hasLocalhost = endpoints.some(url => url.includes('localhost'));

  if (hasLocalhost) {
    console.error('❌ ERROR: Production environment is using localhost URLs!');
    console.error('Check your environment configuration and build process.');
  } else {
    console.log('✅ Production API endpoints configured correctly');
  }
} else {
  console.log('✅ Development/Local API endpoints loaded');
}
